<template>
  <div class="receipts-add mt-1">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm phiếu thu</h1>
      <div class style="float: right">
        <button type="button" class="btn btn-light" @click="checkCloseAdd()">Hủy bỏ</button>
        <button
          class="btn btn-outline-secondary ml-2"
          v-if="
            dataPermission &&
            dataPermission.includes('SCON_RECEIPT_COLLECT') &&
            dataInsert.paymentType !== 'CUSTOMER_TRANSFER'
          "
          @click="collectedMoney(false)"
        >
          Thu tiền
        </button>
        <button
          class="btn btn-outline-secondary ml-2"
          @click="sendApproved()"
          v-if="dataInsert.paymentType === 'CUSTOMER_TRANSFER'"
        >
          Gửi duyệt
        </button>
        <button type="button" class="btn btn-primary ml-2" @click="addReceipts()">Lưu lại</button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div v-if="loadingMerchant" class="card-body p-10 b-t-1-869fb229 text-center">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
      </div>

      <div v-else>
        <ValidationObserver ref="receiptsAdd" class="card-body px-20 mt-2 row">
          <form class="col-md-6">
            <h1 class="form-inner-heading mb-1">Thông tin</h1>

            <ValidationProvider rules="required" vid="merchantName" name="Merchant">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Merchant <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    type="button"
                    class="form-control text-left"
                    v-model="nameMCSelected"
                    placeholder="Chọn merchant"
                    data-toggle="modal"
                    data-target="#exampleModal"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="contract" name="Hợp đồng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Số hợp đồng <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    class="select-contract"
                    v-model="dataInsert.contractId"
                    @change="getListAppendix($event)"
                    :options="dataContract"
                    placeholder="Số hợp đồng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row">
              <label for class="col-sm-3 col-form-label">Số phụ lục</label>
              <div class="col-sm-7">
                <Select2
                  class="select-appendix"
                  v-model="dataInsert.appendixId"
                  :options="dataAppendix"
                  @change="getInfoByAppendix($event)"
                  placeholder="Số phụ lục"
                  title="Ghi chú"
                  v-b-popover.hover.focus.rightbottom="'Chỉ chọn phụ lục khi mua thêm'"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for class="col-sm-3 col-form-label">Mã phiếu thu</label>
              <div class="col-sm-7">
                <input v-model="dataInsert.receiptCode" type="text" disabled class="form-control" />
              </div>
            </div>

            <div class="form-group row">
              <label for class="col-sm-3 col-form-label">Số tiền phải thu</label>
              <div class="col-sm-7">
                <input
                  :value="dataInsert.amount | transformMoney"
                  type="text"
                  disabled
                  class="form-control"
                />
              </div>
            </div>

            <ValidationProvider rules="required" vid="paymentType" name="Hình thức thanh toán">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Hình thức thanh toán <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    class="select-payment-type"
                    v-model="dataInsert.paymentType"
                    :options="dataTypePayment"
                    @select="selectPaymentType()"
                    placeholder="Hình thức"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="receiptDate" name="Ngày đã thu">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Ngày đã thu <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <datepicker
                    format="dd/MM/yyyy"
                    :language="vi"
                    class="receipt-date"
                    v-model="dataInsert.receiptDate"
                    placeholder="Chọn ngày đã thu"
                  ></datepicker>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <!-- <div class="form-group row"
              v-if="dataInsert.paymentType &&
                  dataInsert.paymentType === 'CUSTOMER_TRANSFER'"
            >
              <label for class="col-sm-3 col-form-label"
                >Nội dung phải thu</label
              >
              <div class="col-sm-7">
                <input
                  v-model="dataInsert.description"
                  type="text"
                  disabled
                  class="form-control"
                />
              </div>
            </div> -->

            <ValidationProvider
              rules="required|minMaxName_2"
              vid="transactionCode"
              name="Mã giao dịch"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">
                  Mã giao dịch đã thu <span style="color: red">*</span>
                </label>
                <div class="col-sm-7">
                  <div class="input-group">
                    <input
                      type="text"
                      v-model="dataInsert.transactionCode"
                      @focus="checkBeforeInput()"
                      class="form-control"
                      :readonly="selectedTransactions.length > 0"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary"
                        @click="openTransactionModal()"
                        type="button"
                        title="Tìm giao dịch từ hệ thống"
                      >
                        <i class="bx bx-search"></i> Tìm GD
                      </button>
                    </div>
                  </div>

                  <!-- Hiển thị thông tin giao dịch đã chọn -->
                  <div v-if="selectedTransactions.length > 0" class="mt-2">
                    <div class="alert alert-info py-2 px-3">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>
                            {{
                              selectedTransactions.length === 1
                                ? '1 GD - 1 phiếu thu'
                                : 'Nhiều GD - 1 phiếu thu'
                            }}
                          </strong>
                          <br />
                          <small>
                            Đã chọn {{ selectedTransactions.length }} giao dịch - Tổng tiền:
                            {{ totalSelectedAmount | transformMoney }}đ
                          </small>
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          style="width: 28px"
                          @click="clearSelectedTransactions()"
                          title="Xóa lựa chọn"
                        >
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <p class="text-danger">{{ errors[0] }}</p>
                  <p
                    class="text-danger"
                    v-show="
                      dataInsert.transactionCode === '000000' &&
                      dataInsert.paymentType &&
                      dataInsert.paymentType !== 'CUSTOMER_TRANSFER'
                    "
                  >
                    Vui lòng nhập mã giao dịch
                  </p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              rules="required"
              vid="issuerCode"
              name="Ngân hàng"
              v-if="dataInsert.paymentType && dataInsert.paymentType === 'CUSTOMER_TRANSFER'"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Ngân hàng nhận tiền Nextpay<span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    class="select-payment-type"
                    v-model="dataInsert.issuerCode"
                    :options="dataListIssuer"
                    placeholder="Chọn ngân hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="maxReceipt_2" vid="note" name="Ghi chú">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ghi chú</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataInsert.note"
                    type="text"
                    class="form-control"
                    @focus="checkBeforeInput()"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div v-if="showReceiptDate" style="height: 30vh"></div>
          </form>

          <form class="col-md-6">
            <div class="img-list-wrapper">
              <UploadMultiple
                @syncFile="syncFile"
                :lsData="fileUploads"
                title="Ảnh giải trình"
                titleTag="h1"
                titleClass="form-inner-heading"
                uniqueKey="images"
              />
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- Modal select Merchant -->
    <div
      class="modal fade"
      style="max-height: 100vh"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Chọn Merchant để tạo phiếu thu</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeAddMerchant()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group row">
              <b-input-group class="col-sm-12">
                <b-form-input
                  v-model="search.textSearch"
                  @input="fetchListMC"
                  @keyup.enter="fetchListMC()"
                  placeholder="Tên MC/Email/Số điện thoại"
                ></b-form-input>
                <b-input-group-append>
                  <b-button variant="outline-secondary" @click="fetchListMC()">Tìm kiếm</b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <div class="table-responsive" style="max-height: 55vh; overflow-y: auto">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th>Merchant</th>
                    <th>Vùng kinh doanh</th>
                  </tr>
                </thead>
                <tbody v-if="loading">
                  <tr>
                    <td colspan="11" align="center">
                      <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="table-row" v-for="(item, index) in dataListMC" :key="index">
                    <td>
                      <b-form-checkbox
                        class="text-center"
                        v-model="selectedMC"
                        @change="checkSelectMC(item.customerId)"
                        :value="item.customerId"
                      />
                    </td>
                    <td>
                      <b>Người đại diện:</b> {{ item.customerName }}<br />
                      <b>MC:</b> {{ item.merchantName }}<br />
                      <b>Email:</b> {{ item.email }} <br />
                      <b>SĐT:</b> {{ item.mobile }}
                    </td>
                    <td>
                      {{ item.regionId | transfromRegion(dataConfigRegion) }}
                      <br />
                      {{ item.city }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination-bottom">
              <b-pagination
                v-model="search.page"
                :total-rows="pagination.total"
                :per-page="search.limit"
                class="fl-right mr-2"
              ></b-pagination>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href=""
              data-dismiss="modal"
              aria-label="Close"
              class="btn btn-light"
              @click="closeAddMerchant()"
              >Đóng</a
            >
            <a href="" class="btn btn-primary" @click="submitMerchant()" data-dismiss="modal"
              >Xác nhận</a
            >
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModalSuccess">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalSuccess = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-success2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messSuccess }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalSuccess = false"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalAddSuccess">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalAddSuccess = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-success2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messSuccess }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="(showModalAddSuccess = false), closeAdd()"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalErr">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalErr = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalErr = false"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalErrCheckTrans">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalErrCheckTrans = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="(showModalErrCheckTrans = false), closeAdd()"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="showModalErrCheckTrans = false"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalCollectMoney">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalCollectMoney = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalCollectMoney = false"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="(showModalCollectMoney = false), collectedMoney(true)"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalCheckBack">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalCheckBack = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalCheckBack = false"
                    data-dismiss="modal"
                  >
                    Không
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="(showModalCheckBack = false), closeAdd()"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <TransactionSearchModal
      v-model="showTransactionModal"
      title="Tìm giao dịch gắn cho phiếu thu"
      :multiple="true"
      :max-selection="10"
      @confirm="onTransactionConfirm"
      @selection-change="onSelectionChange"
    />
  </div>
</template>

<script>
  import $ from 'jquery'
  import { mapGetters } from 'vuex'
  import { ReceiptService } from '@/services/receipts.service'
  import { ContractService } from '@/services/contract.service'
  import { StaffService } from '@/services/staff.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { CommonService } from '@/services/common.service'
  import TransactionSearchModal from './TransactionSearchModal'

  export default {
    data() {
      return {
        selectedMC: [],
        dataInsert: {
          contractId: '',
          appendixId: '',
          transactionCode: '',
          amount: '',
          issuerCode: '',
          description: '',
          uploadImgs: [],
        },
        nameMCSelected: '',
        contractSelected: '',
        dataUser: JSON.parse(localStorage.getItem('userData')),
        showModalSelectMC: false,
        dataListMC: [],
        dataConfigRegion: [],
        search: {
          limit: 50,
          page: 1,
        },
        loading: false,
        pagination: {
          total: 0,
        },
        loadingMerchant: false,
        dataContract: [],
        dataAppendix: [],
        dataAppendixOriginal: [],
        dataListIssuer: [],
        showModalSuccess: false,
        showModalAddSuccess: false,
        messSuccess: '',
        showModalErr: false,
        showModalErrCheckTrans: false,
        messErr: '',
        dataTypePayment: [
          { id: 'CUSTOMER_CARD', text: 'Quẹt thẻ khách' },
          { id: 'SALE_CARD', text: 'Quẹt thẻ Sales' },
          { id: 'CUSTOMER_TRANSFER', text: 'Khách chuyển khoản' },
        ],
        checkShowMposTrans: false,
        showModalCheckBack: false,
        vi: vi,
        showModalCollectMoney: false,
        dataContractOrigin: [],
        checkAddSucessBeforeApprove: false,
        receiptIdApproved: '',
        notiAddBeforeApprove: '',
        addSuccessNotApprove: false,
        dataUploadImage: [],
        fileUploads: [],
        showReceiptDate: false,
        showTransactionModal: false,
        selectedTransactions: [],
      }
    },

    components: {
      UploadMultiple,
      TransactionSearchModal,
    },

    mixins: [prepareQueryParamsMixin],

    created() {
      this.getListMerchant()
      this.getRegions()
      this.getListIssuerMpos()
    },

    mounted() {
      this.checkSelect()
    },

    updated() {
      this.checkSelect()
      this.checkDatePickerOpend()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      totalSelectedAmount() {
        return this.selectedTransactions.reduce((total, transaction) => {
          return total + (transaction.remainingAmount || transaction.amount || 0)
        }, 0)
      },
    },

    filters: {
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      transformPaymentType(data, dataTypePayment) {
        const dataReturn = dataTypePayment.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      transformMoney(data) {
        return data ? data.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : ''
      },
    },

    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.getListMerchant()
      },
    },

    methods: {
      openTransactionModal() {
        // Kiểm tra merchant và contract trước khi mở modal
        if (this.nameMCSelected === '') {
          this.showModalErr = true
          this.messErr = 'Vui lòng chọn Merchant trước !'
          return
        }
        if (this.dataInsert.contractId === '') {
          this.showModalErr = true
          this.messErr = 'Vui lòng chọn hợp đồng trước !'
          return
        }
        this.showTransactionModal = true
      },

      onTransactionConfirm(data) {
        this.selectedTransactions = data.transactions

        // Cập nhật mã giao dịch
        if (data.transactions.length === 1) {
          // Trường hợp 1 GD - 1 phiếu thu
          this.dataInsert.transactionCode = data.transactions[0].transactionCode
        } else if (data.transactions.length > 1) {
          // Trường hợp nhiều GD - 1 phiếu thu
          const transactionCodes = data.transactions.map(t => t.transactionCode).join('; ')
          this.dataInsert.transactionCode = `${transactionCodes}`
        }
      },

      onSelectionChange(selectedTransactions) {
        // console.log('Selection changed:', selectedTransactions)`
      },

      clearSelectedTransactions() {
        this.selectedTransactions = []
        this.dataInsert.transactionCode = ''
      },
      async checkCloseAdd() {
        this.showModalCheckBack = true
        this.messErr = 'Bạn có chắc chắn muốn huỷ bỏ thao tác không ?'
      },

      async closeAdd() {
        this.$router.push('/list-receipts')
      },

      async addReceipts() {
        const isSuccess = await this.$refs.receiptsAdd.validate()
        if (!isSuccess) {
          this.showModalErr = true
          this.messErr = 'Vui lòng điền đúng thông tin phiếu thu !'
          return
        }
        try {
          if (this.dataInsert.paymentType && this.dataInsert.paymentType !== 'CUSTOMER_TRANSFER') {
            delete this.dataInsert.issuerCode
          }
          const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
          this.dataInsert.uploadImgs = files.map(s => s.urlFile)
          this.dataInsert.receiptDate = new Date(this.dataInsert.receiptDate).getTime()
          const response = await ReceiptService.createReceipt(this.dataInsert)
          if (response.code === 1000) {
            this.addSuccessNotApprove = true
            this.checkAddSucessBeforeApprove = true
            this.receiptIdApproved = response.data.receiptId

            this.showModalAddSuccess = true
            this.messSuccess = response.message
          } else {
            this.showModalErr = true
            this.messErr = response.message
          }
        } catch (error) {
          console.log(error)
        }
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },

      fetchListMC() {
        this.getListMerchant()
        if (this.search.textSearch === '') {
          this.search = {
            limit: 50,
            page: 1,
          }
        }
        this.search.page = 1
      },

      closeAddMerchant() {
        setTimeout(() => {
          this.search = {
            limit: 50,
            page: 1,
          }
          this.getListMerchant()
        }, 200)
      },

      async getListMerchant() {
        try {
          this.loading = true
          this.search.userId = this.dataUser.userId
          if (this.search.textSearch === '') delete this.search.textSearch
          const response = await ReceiptService.listMerchant(this.search)
          if (response.code === 1000) {
            this.dataListMC = response.data
            this.pagination.total = response.meta.pagination.total
              ? response.meta.pagination.total
              : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion.push({ id: 0, text: 'Tất cả' })
          data.data.map(e => {
            this.dataConfigRegion.push({ id: e.id, text: e.name })
          })
        }
      },

      async submitMerchant() {
        try {
          this.loadingMerchant = true
          const item = this.dataListMC.filter(e => e.customerId === this.selectedMC[0])
          if (item.length) {
            this.nameMCSelected = item[0].merchantName
            await this.getListContract(item[0].customerId)
            await this.generateReceiptCode()
          } else {
            this.nameMCSelected = ''
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingMerchant = false
        }
      },

      checkSelectMC(item) {
        this.selectedMC = this.selectedMC.filter(e => e === item)
      },

      async getListContract(customerId) {
        try {
          const response = await ReceiptService.listContractByCustomer({
            customerId: customerId,
          })
          if (response.code === 1000) {
            this.dataContractOrigin = response.data
            this.dataContract = response.data.map(e => {
              return { id: e.contractId, text: e.code }
            })
            if (this.dataContract.length === 1) this.dataInsert.contractId = this.dataContract[0].id

            if (response.data.length === 0) {
              this.showModalErr = true
              this.messErr = 'Merchant chưa có Hợp đồng. Vui lòng kiểm tra lại'
            }
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getListAppendix(contractId) {
        try {
          const response = await ReceiptService.listAppendixByContract({
            contractId: contractId,
          })
          if (response.code === 1000) {
            this.dataAppendixOriginal = response.data
            this.dataAppendix = response.data.map(e => {
              return { id: e.appendixId, text: e.fullCode }
            })
          }

          const contractData = this.dataContractOrigin.filter(e => e.contractId === contractId)
          this.dataInsert.amount = contractData.length ? contractData[0].price : ''
        } catch (error) {
          console.log(error)
        }
      },

      async getListIssuerMpos() {
        try {
          const response = await ReceiptService.listIssuerMpos({})
          if (response.code === 1000) {
            this.dataListIssuer = response.data.map(e => {
              return { id: e.issuerCode, text: e.issuerName }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      checkBeforeInput() {
        this.checkValidate('contract')
        this.checkValidate('other')
      },

      checkValidate(key) {
        if ((key === 'contract' || key === 'other') && this.nameMCSelected === '') {
          this.showModalErr = true
          this.messErr = 'Vui lòng chọn Merchant trước !'
        } else if (key === 'other' && this.dataInsert.contractId === '') {
          this.showModalErr = true
          this.messErr = 'Vui lòng chọn hợp đồng trước !'
        }
      },

      async getInfoByAppendix(appendixId) {
        const appendixData = this.dataAppendixOriginal.filter(e => e.appendixId === appendixId)
        this.dataInsert.amount = appendixData.length ? appendixData[0].totalPrice : ''

        const resAppendix = await ContractService.getAppendixById({
          appendixId: appendixId,
        })
        if (resAppendix.code === 1000) {
          const isAppendixCreatedWithContract = resAppendix.data.data.isCreatedWithContract
          if (isAppendixCreatedWithContract) {
            this.dataInsert.description = this.dataContract.filter(
              e => e.id === this.dataInsert.contractId
            )[0].text
          } else {
            this.dataInsert.description = this.dataAppendix.filter(
              e => e.id === this.dataInsert.appendixId
            )[0].text
          }
        }
      },

      async checkMposTrans() {
        try {
          if (this.dataInsert.transactionCode === '') {
            this.showModalErr = true
            this.messErr = 'Vui lòng nhập mã chuẩn ghi/GD'
            return
          }
          const response = await ReceiptService.checkMposTrans({
            receiptId: this.receiptId,
            amount: this.dataInsert.amount,
            issuerCode: this.dataInsert.issuerCode,
            transactionCode: this.dataInsert.transactionCode,
          })
          if (response.code === 1000) {
            this.showModalSuccess = true
            this.messSuccess =
              'Kiểm tra ' +
              this.dataInsert.transactionCode +
              ' thành công. Giao dịch đang ở trạng thái ' +
              response.data.tranStatusDisplay

            // this.dataInsert.description = response.data.description
            this.dataInsert.tranStatusCode = response.data.tranStatusCode
            if (
              this.dataInsert.amount === response.data.amount &&
              (response.data.tranStatusCode === 'SETTLED' ||
                response.data.tranStatusCode === 'TRANSFERED')
            ) {
              this.checkShowMposTrans = true
            }
          } else if (response.code === 999) {
            this.showModalErrCheckTrans = true
            this.messErr =
              'Không kiểm tra được thông tin GD bên mPOS. Vui lòng kiểm tra lại Mã chuẩn chi/mã GD'
          } else if (response.code === 998) {
            this.showModalErrCheckTrans = true
            this.messErr =
              'Mã chuẩn chi tồn tại ở nhiều giao dịch. Vui lòng nhập mã giao dịch và nhấn Kiểm tra lại để hoàn thiện phiếu thu'
          } else if (response.code === 997) {
            this.showModalErr = true
            this.messErr =
              'Số tiền trên giao dịch mPOS khác số tiền trên phiếu thu. Vui lòng kiểm tra lại'
          } else {
            this.showModalErr = true
            this.messErr = response.message
          }
        } catch (error) {
          console.log(error)
        }
      },

      async collectedMoney(allowSaveStatus) {
        try {
          this.dataInsert.receiptDate = new Date(this.dataInsert.receiptDate).getTime()
          const response = await ReceiptService.collectedMoneyContractReceipt({
            amount: this.dataInsert.amount,
            contractId: this.dataInsert.contractId,
            appendixId: this.dataInsert.appendixId,
            transactionCode: this.dataInsert.transactionCode,
            paymentType: this.dataInsert.paymentType,
            receiptCode: this.dataInsert.receiptCode,
            note: this.dataInsert.note,
            receiptDate: this.dataInsert.receiptDate,
            allowSave: allowSaveStatus,
            issuerCode: this.dataReceipt.issuerCode,
          })
          if (
            this.dataReceipt.paymentType &&
            this.dataReceipt.paymentType !== 'CUSTOMER_TRANSFER'
          ) {
            delete response.issuerCode
          }
          if (response.code === 1000) {
            this.showModalAddSuccess = true
            this.messSuccess = response.message
          } else {
            this.showModalCollectMoney = true
            this.messErr = response.message
          }
        } catch (error) {
          console.log(error)
        }
      },

      async generateReceiptCode() {
        try {
          const response = await ReceiptService.generateReceiptCode({})
          if (response.code === 1000) {
            this.dataInsert.receiptCode = response.data
          }
        } catch (error) {
          console.log(error)
        }
      },

      async sendApproved() {
        try {
          if (!this.addSuccessNotApprove) await this.addReceiptBeforeApprove()
          if (this.checkAddSucessBeforeApprove) {
            const response = await ReceiptService.sendToApproveReceipt_detail({
              receiptId: this.receiptIdApproved,
            })
            if (response.code === 1000) {
              this.showModalAddSuccess = true
              this.messSuccess = response.message
            } else {
              this.showModalErr = true
              this.messErr = response.message
            }
          } else {
            this.showModalErr = true
            this.messErr = this.notiAddBeforeApprove
          }
        } catch (error) {
          console.log(error)
        }
      },

      async addReceiptBeforeApprove() {
        const isSuccess = await this.$refs.receiptsAdd.validate()
        if (!isSuccess) {
          this.showModalErr = true
          this.messErr = 'Vui lòng điền đúng thông tin phiếu thu !'
          return
        }
        try {
          if (this.dataInsert.paymentType && this.dataInsert.paymentType !== 'CUSTOMER_TRANSFER') {
            delete this.dataInsert.issuerCode
          }
          this.dataInsert.receiptDate = new Date(this.dataInsert.receiptDate).getTime()
          const response = await ReceiptService.createReceipt(this.dataInsert)
          if (response.code === 1000) {
            this.checkAddSucessBeforeApprove = true
            this.receiptIdApproved = response.data.receiptId
          } else {
            this.checkAddSucessBeforeApprove = false
            this.notiAddBeforeApprove = response.message
          }
        } catch (error) {
          console.log(error)
        }
      },

      selectPaymentType() {
        if (this.dataInsert.paymentType && this.dataInsert.paymentType === 'CUSTOMER_TRANSFER') {
          this.dataInsert.issuerCode = this.dataListIssuer[0].id
        } else {
          delete this.dataInsert.issuerCode
        }
      },

      checkSelect() {
        $('.select-contract').click(() => {
          this.checkValidate('contract')
        })
        $('.select-appendix').click(() => {
          this.checkValidate('other')
        })
        $('.receipt-date').click(() => {
          this.checkValidate('other')
        })
        $('.select-payment-type').click(() => {
          this.checkValidate('other')
        })
      },

      checkDatePickerOpend() {
        $('.receipt-date').click(() => {
          this.showReceiptDate = true
        })
        $('.receipt-date').focusout(() => {
          this.showReceiptDate = false
        })
      },
      syncFile(files) {
        this.fileUploads = files
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }

  .receipts-add {
    margin-top: -1rem;
  }

  .pagination-bottom {
    margin-bottom: -1rem;
  }
</style>
